/** Hub bundle round-trips and embedded VFS storage get unhappy past this size. */
export const MAX_FILE_SIZE_BYTES = 100 * 1024 * 1024;
export const MAX_FILE_SIZE_LABEL = '100 MB';
